import * as React from "react";
import PropriedadeTopo from "./topo";
import { PropriedadeDetalhe } from "./detalhe";
import { PropriedadeBottom } from "./bottom";
import Utils from "../../helper/utils";

export const PropriedadePage = () => {
  Utils.setDocumentTitle("Propriedades");

  return (
    <React.Fragment>
      <PropriedadeDetalhe />
      <PropriedadeBottom />
    </React.Fragment>
  );
};
